import React, { useState } from 'react'

export default function SupplierDashboards() {
  const [loading, setLoading] = useState(true);
  return (
    <>


      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          {loading ? <h1 className="h2"><i class="fa-solid fa-spinner fa-spin"></i></h1> : <h1 className="h2">Supplier Dashboard</h1>}

        </div>
        <div>

          <iframe
            src="https://lookerstudio.google.com/embed/u/0/reporting/35e7fc10-cc7b-48f0-8df9-56ea40e1709f/page/p_87cf6sse5c"
            onLoad={() => setLoading(false)}
            width={'1225'}
            height={'1000'}
            style={{ display: loading ? 'none' : 'block' }}
          />
        </div>
      </main>
    </>
  )
}
